import * as Sentry from '@sentry/react';
import { AxiosError, isAxiosError } from 'axios';

type BeforeSend = NonNullable<Parameters<typeof Sentry.init>[0]['beforeSend']>;
type BeforeSendEvent = Parameters<BeforeSend>[0];
type BeforeSendHint = Parameters<BeforeSend>[1];

const isIgnoredAxiosError = (hint?: BeforeSendHint): boolean => {
    return (
        isAxiosError(hint?.originalException) &&
        (hint.originalException.response?.status === 404 ||
            hint.originalException.code === AxiosError.ERR_CANCELED ||
            hint.originalException.code === AxiosError.ERR_NETWORK)
    );
};

const isAbortError = (event: BeforeSendEvent): boolean => {
    return event.exception?.values?.some((exception) => exception.type === 'AbortError') || false;
};

export const beforeSend: BeforeSend = (event, hint) => {
    if (isIgnoredAxiosError(hint) || isAbortError(event)) {
        return null;
    }

    return event;
};
